import { Dispatch, SetStateAction } from 'react';
import Swiper from 'swiper';

import { PlannedInfo } from '@/components/planning/dto';

import User from '../user/User';
import UserEmployment from '../user-employment/UserEmployment';
import classes from './TableItem.module.scss';

interface Props {
	data: PlannedInfo;
	setThumb: Dispatch<SetStateAction<Swiper[]>>;
	isUnassigned: boolean;
}

const TableItem = ({ data, setThumb, isUnassigned }: Props) => {
	return (
		<div className={classes.container}>
			<User
				isUnassigned={isUnassigned}
				data={data.employee}
				employmentPercentage={data.employment_percentage}
				projectCount={data.project_count}
			/>
			<UserEmployment data={data.bookings} id={data.employee.id} setThumb={setThumb} />
		</div>
	);
};

export default TableItem;
